import Dexie from "dexie";

class Request {
  static dbName = "RequestStore";
  static dbVersion = 1;
  static dbStoreName = "requests";
  static handleFetchRequest({
    url,
    proxy,
    getParams,
    postParams,
    method,
    bodyType,
  }) {
    let effectiveurl = url;
    if (getParams && getParams.length) {
      effectiveurl =
        effectiveurl + (effectiveurl.indexOf("?") !== -1 ? "&" : "?");
      effectiveurl =
        effectiveurl +
        getParams
          .map(({ key, value }) => {
            return value ? `${key}=${value}` : `${key}`;
          })
          .join("&");
    }
    if (proxy) {
      effectiveurl = proxy + effectiveurl;
    }
    const options = {
      method,
      headers: {},
      credentials: "same-origin", // 'include' would also send HTTP Credentials cross origin
      redirect: "follow", // manual, *follow, error
      mode: "cors",
      referrerPolicy: "origin-when-cross-origin",
    };
    if (postParams.length > 0) {
      if (bodyType) {
        options.headers["Content-Type"] = bodyType;
        if (typeof postParams == "object") { options.body = JSON.stringify(postParams) }
        else { options.body = postParams.toString(); } //TODO
      } else {
        const data = new FormData();
        postParams.map(({ key, value }) => {
          data.append(key, typeof value === "object" ? JSON.stringify(value) : value);
        });
        options.body = data;
        // options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      }
    }
    return fetch(effectiveurl, options);
  }

  static handleDBRequest({ key }) {
    return new Promise((resolve, reject) => {
      Request.db[Request.dbStoreName]
        .get({ key })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(`IDB Error: ${error.stack || error}`);
        });
      // reject("Not yet implemented");
    });
  }

  static saveToDB({ key, data, url }) {
    const timestamp = new Date() * 1;
    return new Promise((resolve, reject) => {
      return new Promise((resolve, reject) => {
        Request.db[Request.dbStoreName]
          .put({ key, timestamp, url, data })
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(`IDB Error: ${error.stack || error}`);
          });
        // reject("Not yet implemented");
      });
    });
  }

  static handleRequest({
    key, //für indexedDB
    proxy,
    retries, // # retries, if not set the request will not be retried
    url, //fertig zusammengebaute URL, mit allen Parametern reingebautm, wenn in der URL /{xyz}/ waren
    method, // POST, GET, etc
    getParams, // [{key: "abc", value: *}] Array von key-value paren
    postParams, // IDK
    bodyType, // aus der config
    responseHandlingFunction, // response => value "entpackt" die response
    isErrorFunction, //  response => bool, "ist respones ein error"; timeout => daniel
    errorMessageFunction, // response => errormessage,
    useCheckedOut, // true => use checked out kram anstatt online service
    timeout,
  }) {
    // online & useCheckedOut = false => frage daten Vom server ab, Speichere sie in der IDB
    // useCheckedOut => gebe daten aus der IDB zurück (unverändert, um hist berechnung kümmert sich der singleRequestHandler)
    // History muss aus IDB erzeugt werden können bei offlinestart.... <_< aber kriegt man mittels der anderen anfragern hin
    let timeouted = false;
    let nativTimeout = null;
    let promise = null;
    if (useCheckedOut) {
      //TODO: in db abspeichern und dann dementsprechend resolven oder rejecten, aber was soll passieren, fallsim online zustand das ganze schief läuft? einfach ignorieren oder fehlschlagen? => einfach als parameter in handleRequest?
      promise = new Promise((resolve, reject) => {
        Request.handleDBRequest({ key })
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.toString());
          });
      });
    } else {
      promise = new Promise((resolve, reject) => {
        Request.handleFetchRequest({
          url,
          proxy,
          getParams,
          postParams,
          method,
          bodyType,
        })
          .then((response) => {
            if (!timeouted) {
              if (nativTimeout) {
                clearTimeout(nativTimeout);
              }
              try {
                if (response.ok) {
                  Promise.all([isErrorFunction(response.clone())])
                    .then(([isError]) => {
                      if (isError) {
                        errorMessageFunction(response).then((error) =>
                          reject(error)
                        );
                      } else {
                        Promise.all([responseHandlingFunction(response)])
                          .then(([data]) => {
                            // For Promise.all it doesnt mind if a static value is provided
                            Request.saveToDB({ key, data, url })
                              .then(() => {
                                resolve(data);
                              })
                              .catch((e) => {
                                console.error(e);
                                reject("Failed to save Response to Indexed DB");
                              });
                            resolve(data);
                          })
                          .catch((e) => reject(e.toString()));
                      }
                    })
                    .catch(([value]) => {
                      console.error("Request error: ", value);
                    });

                  // if (isErrorFunction(response.clone())) {
                  //   reject(errorMessageFunction(response));
                  // } else {
                  //   Promise.all([responseHandlingFunction(response)])
                  //     .then(([data]) => {
                  //       // For Promise.all it doesnt mind if a static value is provided
                  //       Request.saveToDB({ key, data, url })
                  //         .then(() => {
                  //           resolve(data);
                  //         })
                  //         .catch((e) => {
                  //           console.error(e);
                  //           reject("Failed to save Response to Indexed DB");
                  //         });
                  //       resolve(data);
                  //     })
                  //     .catch((e) => reject(e.toString()));
                  // }
                } else {
                  reject(
                    `Server responded with Code ${response.status} "${response.statusText}"`
                  ); // TODO: maybe catch it with the isErrorFuntion
                }
              } catch (error) {
                const errorTxt = `Something went wrong in response handling: ${error.toString()}`;
                console.error(errorTxt);
                reject(errorTxt);
              }
            }
          })
          .catch((error) => {
            console.error(error);
            reject(error.toString());
          });
      });
    }
    /*
        return new Promise((resolve, reject)=>{
            if(retries && retries > 0){
                promise.then(data=>{resolve(data)}).catch(error=>{
                    console.error("Request failed. Will retry now", error);
                    Request.handleRequest(handleRequest({
                        key, //für indexedDB
                        proxy,
                        url, //fertig zusammengebaute URL, mit allen Parametern reingebautm, wenn in der URL /{xyz}/ waren
                        method, // POST, GET, etc
                        getParams, // [{key: "abc", value: *}] Array von key-value paren
                        postParams, // IDK 
                        bodyType, // aus der config
                        responseHandlingFunction, // response => value "entpackt" die response
                        isErrorFunction,  //  response => bool, "ist respones ein error"; timeout => daniel
                        errorMessageFunction, // response => errormessage, 
                        useCheckedOut, // true => use checked out kram anstatt online service
                        timeout,
                        tries: tries-1
                    })).then((data)=>{
                        resolve(data);
                    }).catch((error)=>{
                        reject(error);
                    });
                });
            } else {
                reject(`Request to ${url} failed. ${error.toString()}`);
            }
        });
            */

    const retry = (resolve, reject) => {
      const options = {
        key, //für indexedDB
        proxy,
        retries: retries - 1, // # retries, if not set the request will not be retried
        url, //fertig zusammengebaute URL, mit allen Parametern reingebautm, wenn in der URL /{xyz}/ waren
        method, // POST, GET, etc
        getParams, // [{key: "abc", value: *}] Array von key-value paren
        postParams, // IDK
        bodyType, // aus der config
        responseHandlingFunction, // response => value "entpackt" die response
        isErrorFunction, //  response => bool, "ist respones ein error"; timeout => daniel
        errorMessageFunction, // response => errormessage,
        useCheckedOut, // true => use checked out kram anstatt online service
        timeout,
      };

      setTimeout(() => {
        Request.handleRequest(options)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      }, Math.floor(Math.random() * 100) + 100); // Wait random time between 100 and 200 milliseconds before retry
    };

    const handleError = (msg, resolve, reject) => {
      console.error(msg);
      if (retries && retries > 0) {
      } else {
        reject(msg);
      }
    };

    return new Promise((resolve, reject) => {
      if (timeout && !useCheckedOut) {
        nativTimeout = setTimeout(() => {
          // timeout makes no sense, if data source is indexeddb
          timeouted = true;
          handleError(
            `Request timeouted after ${timeout / 1000} seconds`,
            resolve,
            reject
          );
        }, timeout);
        promise
          .then((data) => {
            if (!timeouted) {
              resolve(data);
            }
          })
          .catch((data) => {
            if (!timeouted) {
              handleError(data, resolve, reject);
            }
          });
      } else {
        return promise
          .then((data) => resolve(data))
          .catch((error) => handleError(error, resolve, reject));
      }
    });
    // return promise; // mit retries vlt etwas anders lösen
  } //returns new Promise?
  // .then((val)=>{
  //     RequestStore.requests[this.key].setValue(val);
  //     RequestStore.requests[this.key].setState("success");
  // }) Key: {BTTIds: [123,45,67]}
  // .catch((error)=>{
  //     RequestStore.requests[this.key].setMessage(error);
  //     RequestStore.requests[this.key].setState("error");
  // });
  static storeRequest({
    key, //für indexedDB
    url, //fertig zusammengebaute URL, mit allen Parametern reingebautm, wenn in der URL /{xyz}/ waren
    getParams, // [{key: "abc", value: *}] Array von key-value paren
    postParams, // IDK
  }) {
    return new Promise((resolve, reject) => {
      const timestamp = new Date() * 1;
      Request.db[Request.dbStoreName]
        .get({ key })
        .then((data) => {
          const entry = {
            timestamp,
            url,
            getParams: [].concat(getParams),
            postParams: [].concat(postParams),
          };
          const newData =
            data !== undefined
              ? data
              : {
                key,
                timestamp,
                requests: [],
              };
          newData.requests.push(entry);
          Request.db[Request.dbStoreName]
            .put(newData)
            .then(() => {
              resolve();
            })
            .catch((error) => {
              reject(`IDB Error: ${error.stack || error}`);
            });
          resolve(data);
        })
        .catch((error) => {
          reject(`IDB Error: ${error.stack || error}`);
        });
    });
  }
  static getRequests(key) {
    return new Promise((resolve, reject) => {
      Request.db[Request.dbStoreName]
        .get({ key })
        .then((data) => {
          if (data !== undefined) {
            resolve(data.requests);
          } else {
            resolve([]);
          }
        })
        .catch((error) => {
          reject(`IDB Error: ${error.stack || error}`);
        });
    });
    // einfach das array was in dem Objekt steht zurückgeben
    // [(timeStamp: 123, url, ..),(timeStamp: 124, url, ..)]
  }

  static initIndexedDB() {
    Request.db = new Dexie(Request.dbName);
    Request.db.version(Request.dbVersion).stores({
      [Request.dbStoreName]: "&key,timestamp",
    });
    return new Promise((resolve) => {
      resolve();
    });
  }
}
export default Request;